import { Decisions } from './decisions';
import css from './card.module.scss';

interface Props {
    title: string;
    data: ReadonlyMap<string, string>;
}
export function Card({ title, data }: Props) {
    return (
        <article className={css.card}>
            <p className={css.title}>{title}</p>
            <ul className={css.list}>
                {Array.from(data.entries())
                    .filter(([key]) => key !== 'x-petm-decisions')
                    .map(([key, value]) => (
                        <li key={key} className={css.item}>
                            <span className={css.name}>{key}</span>
                            <span className={css.value}>{value}</span>
                        </li>
                    ))}

                {title === 'Cookies' && <Decisions data={data} />}

                {!Array.from(data.entries()).length && <li>No items</li>}
            </ul>
        </article>
    );
}
